/**
 * ROUTE_CONFIG
 * 
 * Each route declares:
 *   path        - the URL
 *   permission  - permission_code required to access it (from officer.permissions[])
 *   defaultFor  - if set, this is the landing page for officers with this permission
 *                 Used to determine post-login redirect automatically.
 *                 First match wins — order matters.
 * 
 * To give a role access to a route → assign that permission to the role on the backend.
 * No role names here at all.
 */
export const ROUTE_CONFIG = [
  {
    path: "/applications",
    permission: "APPLICATION_VIEW",
    // defaultFor: true,   // first route the officer has access to → used as landing page
    landingPriority: 1,
  },
  {
    path: "/leads",
    permission: "LEAD_VIEW",
    landingPriority: 4,
  },
  {
    path: "/tvr",
    permission: "TVR_VIEW",
    // defaultFor: true,
    landingPriority: 5,
  },
  {
    path: "/insurance",
    permission: "INSURANCE_VIEW",
    // defaultFor: true,
    landingPriority: 7,
  },
  {
    path: "/reports",
    permission: "REPORTS_VIEW",
    // defaultFor: true,
    landingPriority: 6,
  },
  {
    path: "/tranche-view",
    permission: "TRANCHE_OPEN",
    landingPriority: 9,
  },
  {
    path: "/analytics",
    // permission: "ANALYTICS_VIEW",
    permission: "APPLICATION_STAGES_SUMMARY_VIEW",
    landingPriority: 11,
  },
  {
    path: "/analytics-dashboard",
    permission: "ANALYTICS_VIEW",
    landingPriority: 12,
  },
  {
    path: "/user-management",
    permission: "USER_MANAGEMENT_VIEW",
    // defaultFor: true,
    landingPriority: 2,
  },
  // {
  //   path: "/branch-dashboard",
  //   permission: "BRANCH_DASHBOARD_VIEW",
  //   // defaultFor: true,
  //   landingPriority: 3,
  // },
  // {
    //   path: "/task-management/dashboard",
    //   permission: "TASK_VIEW",
    //   defaultFor: true,
    // },
    {
      path: "/task-management/dashboard",
      permission: "QMS_STAGE_VIEW",
      // defaultFor: true,
      landingPriority: 8,
    },
    {
      path: "/rejected-applications",
      permission: "VIEW_REJECTED_APPLICATIONS",
      landingPriority: 10,
    },
    {
      path: "/deleted-applications",
      permission: "VIEW_DELETED_APPLICATIONS",
      landingPriority: 13,
    },
    {
      path: "/team-overview?tab=staff-view",
      permission: "VIEW_TEAM_OVERVIEW",
      landingPriority: 14,
    },
];

/**
 * getDefaultRoute
 * 
 * Given a Set of permission codes, returns the first route
 * the officer is allowed to land on after login.
 * 
 * @param {Set<string>} permissionSet
 * @returns {string} path  e.g. "/applications"
 */
export const getDefaultRoute = (permissionSet) => {
  if (!permissionSet) return "/";

  // const match = ROUTE_CONFIG.find(
  //   route => route.defaultFor && permissionSet.has(route.permission)
  // );

  const accessibleLandingRoutes = ROUTE_CONFIG
                                    .filter((route) =>
                                      route.landingPriority && permissionSet.has(route.permission)
                                    )
                                    .sort(
                                      (a, b) => a.landingPriority - b.landingPriority
                                    );

  // return match?.path ?? "/";
  return accessibleLandingRoutes?.[0]?.path ?? "/";
};